import React from 'react';
import { useTranslation } from 'react-i18next';

import { NotificationStatus } from '@cp-shared-19/frontend-ui';
import { Notification } from '@vwfs-bronson/bronson-react';

export type NoConnectionNotificationProps = {
    testId?: string;
};

export const NoConnectionNotification: React.FC<NoConnectionNotificationProps> = ({ testId }) => {
    const { t } = useTranslation();
    return (
        <Notification
            status={NotificationStatus.error}
            title={t('error.no-connection.title')}
            testId={testId}
            aria-atomic="true"
            aria-live="polite"
            visible
            showCloseButton={false}
        >
            {t('error.no-connection.text')}
        </Notification>
    );
};
